// =================================================================================================================
// Breakpoints
// =================================================================================================================

// SET YOUR BREAKPOINT HERE
// Object of CSS breakpoints in pixels. Copy what you have in SCSS. Goes from smallest to largest.
const breakpoints = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1460,
}

/**
 * Get Current Breakpoint
 * Returns the name of the current breakpoint
 *
 * @param {object} breakpoints All of the CSS breakpoints. The key is the name of the breakpoint and the value is the width
 * @param {boolean} logBreakpoint Whether to log the breakpoint to the console or not
 * @param {string} currentBreakpoint The name of the current breakpoint
 */
function getCurrentBreakpoint(breakpoints, logBreakpoint= false, currentBreakpoint){
    // Get the window width
    let width = window.innerWidth;

    // Set the base breakpoint to the smallest one
    let breakpoint = Object.keys(breakpoints)[0];

    // Loop over the breakpoints object
    Object.entries(breakpoints).forEach(entry => {
        const [breakpointName, breakpointWidth] = entry;
        if (width > breakpointWidth ) {
            breakpoint = breakpointName;
        }
    });

    // If logging in enabled
    if (logBreakpoint) {
        if (currentBreakpoint){
            if (currentBreakpoint !== breakpoint){
                console.log("breakpoint:", breakpoint);
            }
        } else {
            console.log("breakpoint:", breakpoint);
        }
    }

    return breakpoint;
}

// Set breakpoint on page load
let breakpointCurrent = getCurrentBreakpoint(breakpoints, true);

// Change breakpoint on screen resize
window.addEventListener('resize', function (){
    breakpointCurrent = getCurrentBreakpoint(breakpoints, true, breakpointCurrent);
});





// =================================================================================================================
// Nav Bar
// =================================================================================================================

// Set up constants
const nav = document.getElementById("main-nav"); // Navbar
const adminBar = document.getElementById("wpadminbar") // WordPress Admin Bar

// Check for WordPress admin bar and pushes Nav down if it exists
if (adminBar) {
    nav.style.top = adminBar.clientHeight + 'px';
}



// =================================================================================================================
// 360 Rotator
// =================================================================================================================
(function($) {
    let rotator = $('.threesixty-image-rotate');

    if ($('#product').length && rotator.length){

        let model = rotator.attr('class').split(' ')[1].split('-')[1];

        rotator.TreeSixtyImageRotate({
            totalFrames: 29,
            extension:".png",
            imagesFolder: `/wp-content/uploads/products/${model}/`,
            currentFrame: 0,
            navigation: false,
            smallWidth: 700,
            smallHeight: 439
        }).initTreeSixty();

    }

})( jQuery );
